import {
  Dic
} from '$utils'
const tableOption = function (that) {
  return {
    view: '详情',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [{
        label: '通信ID',
        prop: 'communicationId',
        viewDisplay: true,
        overHidden: true,
        span: 24,
        columnWidth: "180px",

      },
      {
        label: '数据地址',
        prop: 'measurePointAddr',
        viewDisplay: true,
        overHidden: true,
        span: 24,
        columnWidth: "100px",
      },
      {
        label: '所属设备组',
        prop: 'deviceWorkGroupName',
        viewDisplay: false,
        overHidden: true,
        span: 24,
        search: true,
        searchSlot: true,
        clearable: true
      },
      {
        label: '设备名称',
        prop: 'parentDeviceName',
        viewDisplay: true,
        overHidden: true,
        span: 24,
        search: true,
        clearable: true,

      },
      {
        label: '位置描述',
        prop: 'deviceName',
        viewDisplay: true,
        overHidden: true,
        span: 24,

      },

      {
        label: '测量属性',
        prop: 'measureMedium',
        viewDisplay: true,
        overHidden: true,
        span: 24,
      },
      {
        label: '阈值',
        prop: 'threshold',
        viewDisplay: true,
        overHidden: true,
        span: 24,

      },
      {
        label: '浓度值%',
        prop: 'concentration',
        viewDisplay: true,
        overHidden: true,
        span: 24,

      },
      {
        label: '状态',
        prop: 'statusList',
        viewDisplay: true,
        overHidden: true,
        span: 24,
        hide: true,
        search: true,
        multiple: true,
        type: 'select',
        dicData: Dic.find('SENU11001', {}, false)
      },
      {
        label: '状态',
        prop: 'status',
        viewDisplay: true,
        overHidden: true,
        span: 24,
        columnWidth: "130px",
      },
      {
        label: '更新时间',
        prop: 'submitTime',
        viewDisplay: true,
        overHidden: true,
        span: 24,
        search: true,
        searchSlot: true,
        columnWidth: "180px",

      },
    ]
  }
}
export default tableOption